module.exports = __webpack_public_path__ + "static/media/MD.d44cbd34.png";